{
  "$id": "wealthlane://forms/plan-management",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../plan-management.domain.json",
  "properties": {
    "name": {
      "$ref": "module://plan-management#properties/name",
      "required": true
    },
    "planTypeCategoryIds": {
      "$ref": "module://plan-management#properties/planTypeCategoryIds",
      "required": true,
      "actionId": "FETCH_PLAN_TYPE_CATEGORY_OPTIONS",
      "dependsOn": [],
      "adapterProps": {
        "multiple": true
      }
    },
    "boardApprovalDate": {
      "$ref": "module://plan-management#properties/boardApprovalDate",
      "required": true
    },
    "shareHolderApprovalDate": {
      "$ref": "module://plan-management#properties/shareHolderApprovalDate",
      "required": true
    },
    "planEffectiveDate": {
      "$ref": "module://plan-management#properties/planEffectiveDate",
      "required": true,
      "reactions": [{
        "watch": ["boardApprovalDate", "shareHolderApprovalDate"],
        "set": "minDate",
        "compute": {
          "operator": "max",
          "operands": [
            { "operator": "field", "name": "boardApprovalDate" },
            { "operator": "field", "name": "shareHolderApprovalDate" }
          ]
        }
      }]
    },
    "poolId": {
      "$ref": "module://plan-management#properties/poolId",
      "required": true,
      "dependsOn": []
    },
    "planTerm": {
      "$ref": "module://plan-management#properties/planTerm",
      "required": true
    },
    "evergreenPlan": {
      "$ref": "module://plan-management#properties/evergreenPlan",
      "required": true
    },
    "evergreenCriteria": {
      "$ref": "module://plan-management#properties/evergreenCriteria",
      "requiredWhen": { "field": "evergreenPlan", "equals": "Yes" },
      "hiddenWhen": { "field": "evergreenPlan", "notEquals": "Yes" }
    },
    "dividendEligibility": {
      "$ref": "module://plan-management#properties/dividendEligibility",
      "required": true
    },
    "planExpiryDate": {
      "$ref": "module://plan-management#properties/planExpiryDate",
      "reactions": [{
        "watch": ["planEffectiveDate", "planTerm"],
        "set": "maxDate",
        "compute": {
          "operator": "dateOffset",
          "source": "planEffectiveDate",
          "years": "planTerm"
        }
      }]
    },
    "description": {
      "$ref": "module://plan-management#properties/description"
    },
    "allowEditPlanRelatedDocuments": {
      "$ref": "module://plan-management#properties/allowEditPlanRelatedDocuments",
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "planDocumentInput": {
      "$ref": "module://plan-management#properties/planDocumentInput",
      "required": true
    },
    "planDocumentExistingIds": {
      "$ref": "module://plan-management#properties/planDocumentExistingIds"
    },
    "planDocumentExistingNames": {
      "$ref": "module://plan-management#properties/planDocumentExistingNames"
    },
    "planDocumentRemovedIds": {
      "$ref": "module://plan-management#properties/planDocumentRemovedIds"
    },
    "optionExpirationDate": {
      "$ref": "module://plan-management#properties/optionExpirationDate",
      "hiddenWhen": {
        "anyOf": [
          { "field": "planTypeCategoryIds", "isEmpty": true },
          { "field": "planTypeCategory", "notContains": "Options" }
        ]
      },
      "requiredWhen": { "field": "planTypeCategory", "contains": "Options" },
      "clearOnHideWhen": true
    },
    "terminationRules": {
      "$ref": "module://plan-management#properties/terminationRules"
    },
    "terminationRuleSetId": {
      "$ref": "module://plan-management#properties/terminationRuleSetId"
    },
    "planTypeCategory": {
      "$ref": "module://plan-management#properties/planTypeCategory"
    },
    "OPEN_TERMINATION_RULES_MODAL": {
      "$ref": "module://plan-management#properties/OPEN_TERMINATION_RULES_MODAL",
      "labelByMode": {
        "create": "Add Termination Rules",
        "edit": "Edit Termination Rules"
      },
      "hiddenWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          { "field": "planTypeCategoryIds", "isEmpty": true },
          {
            "allOf": [
              { "field": "planTypeCategory", "notContains": "Options" },
              { "field": "planTypeCategory", "notContains": "RSU" },
              { "field": "planTypeCategory", "notContains": "PSU" }
            ]
          }
        ]
      }
    },
    "OPEN_GRANT_AGREEMENT_MODAL": {
      "$ref": "module://plan-management#properties/OPEN_GRANT_AGREEMENT_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" }
    },
    "OPEN_GRANT_NOTICE_MODAL": {
      "$ref": "module://plan-management#properties/OPEN_GRANT_NOTICE_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" }
    },
    "OPEN_TERMS_CONDITIONS_DOC_MODAL": {
      "$ref": "module://plan-management#properties/OPEN_TERMS_CONDITIONS_DOC_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" }
    },
    "OPEN_TERMS_CONDITIONS_TEXT_MODAL": {
      "$ref": "module://plan-management#properties/OPEN_TERMS_CONDITIONS_TEXT_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" }
    },
    "grantAgreementDocs": {
      "$ref": "module://plan-management#properties/grantAgreementDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Grant Agreement Document",
        "editActionId": "OPEN_EDIT_PLAN_GRANT_DOCUMENT",
        "editGateField": "allowEditPlanRelatedDocuments",
        "contextIdField": "id",
        "contextIdParamKey": "id",
        "editActionContextKey": "planId"
      }
    },
    "grantNoticeDocs": {
      "$ref": "module://plan-management#properties/grantNoticeDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Grant Notice Document",
        "editActionId": "OPEN_EDIT_PLAN_GRANT_DOCUMENT",
        "editGateField": "allowEditPlanRelatedDocuments",
        "contextIdField": "id",
        "contextIdParamKey": "id",
        "editActionContextKey": "planId"
      }
    },
    "termsConditionDocDocs": {
      "$ref": "module://plan-management#properties/termsConditionDocDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Terms And Condition Document",
        "editActionId": "OPEN_EDIT_PLAN_GRANT_DOCUMENT",
        "editGateField": "allowEditPlanRelatedDocuments",
        "contextIdField": "id",
        "contextIdParamKey": "id",
        "editActionContextKey": "planId"
      }
    },
    "termsConditionTextDocs": {
      "$ref": "module://plan-management#properties/termsConditionTextDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Terms And Condition Text"
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_PLAN_MANAGEMENT",
      "refreshEntities": ["PlanManagement"],
      "invalidateQueries": ["getPlanManagementList"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Plan added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PLAN_MANAGEMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Plan edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PLAN_MANAGEMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
